import { styled } from '@mui/material/styles';

import { List } from '@mui/material';

const StyledList = styled(List)(
  ({ theme, component }) => `
    list-style: ${component === 'ul' ? 'disc' : 'decimal'};
    padding-left: ${theme.DS_spacing(['md'])};
    
  `,
);

export { StyledList };
